<template>
  <div class="list">
    <div class="proinfo">
      <div class="proinfo-hd">
        <div class="wrap">
          <div class="container-fluid">
            <div class="row">
              <div
                class="col-md-6 col-12"
                style="box-sizing: border-box;"
              >
                <swiper
                  class="left"
                  :options="swiperOptions"
                  style="height: 100%"
                >
                  <swiper-slide v-for="(image, index) in list" :key="index">
                    <img :src="image.img" :alt="image.label" />
                  </swiper-slide>
                  <div class="swiper-button-next" slot="button-next"></div>
                  <div class="swiper-button-prev" slot="button-prev"></div>
                </swiper>
              </div>
              <div class="col-md-6 col-12" style="box-sizing: border-box">
                <div class="right">
                  <p class="t1" style="font-size: 24px">{{ myTitle }}</p>
                  <div class="txt" v-if="$route.query.type == '13'">
                    <dd>产品参数</dd>
                    <li><span>品牌：</span>皓泉</li>
                    <li><span>产地：</span>河南</li>
                    <li><span>内芯材质：</span>铜、铝</li>
                    <li><span>可售卖地：</span>全国</li>
                    <li><span>用途：</span>室内家装</li>
                    <li><span>特点：</span>防火、防潮、防腐蚀</li>
                    <li><span>电压等级：</span>450/750V</li>
                    <li><span>颜色：</span>红 蓝 黄 绿 黑 白 双色</li>
                  </div>
                  <div class="txt" v-if="$route.query.type == '14'">
                    <dd>产品参数</dd>
                    <li>
                      <span>规格：</span
                      >VV、VV22、VV23、VV32、VV33、VV42、VV43、VLV、VLV22、VLV23、VLV32、VLV33、VLV42、VLV43、YJV、YJV22、YJV23、YJV32、YJV33、YJV42、YJV43、YJLV、YJLV22、YJLV23、YJLV32、YJLV33、YJLV42、YJLV43
                    </li>
                    <li><span>优势：</span>防火、防潮、防腐蚀</li>
                    <li><span>标称截面：</span>10-300mm</li>
                    <li><span>电压等级：</span>35KV以下</li>
                    <li>
                      <span>用途：</span
                      >可敷设于室内、隧道、电缆沟及管道中、地下、竖井，水中及高落差的场所
                    </li>
                    <li><span> 内芯材质：</span>铝、铜</li>
                    <li><span>芯数：</span>1芯~20芯</li>
                  </div>

                  <div class="txt" v-if="$route.query.type == '15'">
                    <dd>产品参数</dd>
                    <li><span>规格：</span>YC、YGC、YZ、YCW</li>
                    <li><span>电压等级：</span>450/750V</li>
                    <li><span>颜色：</span>黑色</li>
                    <li><span>特点：</span>防火、防潮、防腐蚀</li>
                    <li><span>用途：</span>电气线路设备线路厂房线路企业线路</li>
                    <li><span>内芯材质：</span>铜</li>
                    <li><span>芯数：</span>1芯~5芯</li>
                  </div>

                  <div class="txt" v-if="$route.query.type == '16'">
                    <dd>产品参数</dd>
                    <li>
                      <span>规格：</span
                      >KVV、KVV22、KVVP2、KVVP、KVVP2-22、KVVP22、KVVR、KVVRP
                    </li>
                    <li><span>颜色：</span>黑色</li>
                    <li><span>优势：</span>防火、防潮、防腐蚀</li>
                    <li><span>电压等级：</span>450/750V</li>
                    <li><span>内芯材质：</span>铜</li>
                  </div>

                  <div class="txt"  v-if="$route.query.type == '17'">
                    <dd>产品参数</dd>
                                          <li><span>芯数：</span>多芯</li>
                                          <li><span>标称截面：</span>240mm</li>
                                          <li><span>电压等级：</span>300/500V</li>
                                          <li><span>用途：</span>用于对耐火性能要求比较高的输电场所</li>
                                          <li><span>内芯材质：</span>裸铜线</li>
                                      </div>

                                      <div class="txt" v-if="$route.query.type == '18'">
                    <dd>产品参数</dd>
                                          <li><span>规格：</span>YJLV22、YJV22、YJV、YJLV</li>
                                          <li><span>颜色：</span>黑色</li>
                                          <li><span>优势：</span>防火、防潮、防腐蚀</li>
                                          <li><span>电压等级：</span>10KV~35KV</li>
                                          <li><span>用途：</span>高输电线路,变压器上线,变电站</li>
                                          <li><span>内芯材质：</span>铝、铜</li>
                                          <li><span>芯数：</span>1芯~3芯 </li>
                                      </div>

                                      <div class="txt" v-if="$route.query.type == '19'">
                    <dd>产品参数</dd>
                                          <li><span>规格：</span>RVV、RVVB、RVVP、RVS、ZC-RVS、ZCN-RVS、WDZ-RYS、RVSP</li>
                                          <li><span>颜色：</span>黑 白</li>
                                          <li><span>优势：</span>防火、防潮、防腐蚀</li>
                                          <li><span>电压等级：</span>450/750V</li>
                                          <li><span>用途：</span>家居装修</li>
                                          <li><span>内芯材质：</span>铜</li>
                                      </div>

                                      <div class="txt" v-if="$route.query.type == '20'">
                    <dd>产品参数</dd>
                                          <li><span>标称截面：</span>10mm</li>
                                          <li><span>颜色：</span>黑色</li>
                                          <li><span>优势：</span>防火、防潮、防腐蚀</li>
                                          <li><span>电压等级：</span>35KV以下</li>
                                          <li><span>用途：</span>架空</li>
                                          <li><span>额定电压：</span>10KV</li>
                                      </div>

                                      <div class="txt" v-if="$route.query.type == '21'">
                    <dd>产品参数</dd>
                                          <li><span>规格：</span>JKLYJ、JKLGYJ、JKLV、JK</li>
                                          <li><span>颜色：</span>黑色</li>
                                          <li><span>优势：</span>防火、防潮、防腐蚀</li>
                                          <li><span>电压等级：</span>0.6/1KV 8.7/15KV 26/35KV</li>
                                          <li><span>用途：</span>高输电线路,变压器上</li>
                                          <li><span>内芯材质：</span>铜 铝</li>
                                          <li><span>芯数：</span>1芯、4芯、2芯、3芯</li>
                                      </div>

                                      <div class="txt" v-if="$route.query.type == '22'">
                    <dd>产品参数</dd>
                                          <li><span>规格：</span>BTTZ、BTTRZ、YTTW、NGA-（BTLY）、BBTRZ</li>
                                          <li><span>橙色：</span>橙色</li>
                                          <li><span>优势：</span>不燃、低烟、耐火、无毒</li>
                                          <li><span>用途：</span>通信、音频、广播、音响系统、防盗报警系统</li>
                                          <li><span>额定电压：</span>0.6-1KV</li>
                                          <li><span>芯数：</span>1~5芯</li>
                                          <li><span>内芯材质：</span>无氧铜</li>
                                      </div>
                  <div class="txt" v-if="$route.query.type == '23'">
                    <dd>产品参数</dd>
                    <li><span>规格：</span>YJLHV(TC90)、YJLHY、YJLHV22</li>
                    <li><span>电压等级：</span>0.6KV-35KV</li>
                    <li><span>优势：</span>自重承载力强，抗拉强度和延伸率强</li>
                    <li><span>用途：</span>广泛</li>
                    <li><span>芯数：</span>3芯、4芯、5芯</li>
                    <li><span>标称截面：</span>10-630mm</li>
                  </div>
                  <div class="txt"  v-if="$route.query.type == '24'">
                    <dd>产品参数</dd>
                    <li><span>优势：</span>防火、防潮、防腐蚀</li>
                    <li><span>芯数：</span>1~5芯、3+1、3+2、4+1</li>
                  </div>

                  <div class="txt" v-if="$route.query.type == '25'">
                    <dd>产品参数</dd>
                    <li><span>优势：</span>防火、防潮、防腐蚀</li>
                    <li><span>用途：</span>信号传输</li>
                    <li><span>内芯材质：</span>无氧铜</li>
                    <li><span>芯数：</span>2~61芯</li>
                 </div>

                <div class="txt" v-if="$route.query.type == '26'">
                    <dd>产品参数</dd>
                    <li><span>规格：</span>YJV</li>
                    <li><span>电压等级：</span>35KV以下</li>
                    <li><span>颜色：</span>黑色</li>
                    <li><span>特点：</span>防火、防潮、防腐蚀</li>
                    <li><span>用途：</span>广泛</li>
                    <li><span>内芯材质：</span>铜</li>
                    <li><span>芯数：</span>2~5芯</li>
                    <li><span>标称截面：</span>1-10mm</li>
                </div>
                  <div class="tags">
                    <li><i class="iconfont"></i>质量求生存</li>
                    <li><i class="iconfont"></i>信誉求发展</li>
                    <li><i class="iconfont"></i>管理求效益</li>
                    <li><i class="iconfont"></i>服务拓市场</li>
                  </div>
                  <div class="btn">
                    <a href="#section3">立即订购</a>
                    <div class="con">
                      <i class="iconfont"></i>
                      <div class="rt">
                        <p class="t2">咨询热线：</p>
                        <p class="t3">15837161168</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="proinfo-md">
        <div class="wrap">
          <a href="#section1">产品详情</a>
          <a href="#section4">公司优势</a>
          <a href="#section3">在线订购</a>
        </div>
      </div>
      <div class="proinfo-bd" style="padding-bottom: 0px;">
        <div class="wrap">
          <div class="section section1" id="seciton1">
            <p class="t1">产品详情</p>
            <div class="content">
              <p style="text-align: center">
                <template v-if="$route.query.type == '13'">
                  <img
                    src="/common/1638863498926578.webp"
                    title=""
                    alt="布电线_01-tuya"
                  /><img
                    src="/common/1638863503914744.webp"
                    title=""
                    alt="布电线_02-tuya"
                  /><img
                    src="/common/1638863507392365.webp"
                    title=""
                    alt="布电线_03-tuya"
                  /><img
                    src="/common/1638863512675490.webp"
                    title=""
                    alt="布电线_04-tuya"
                  /><img
                    src="/common/1638863515583231.webp"
                    title=""
                    alt="布电线_05-tuya"
                  /><img
                    src="/common/1638863520721433.webp"
                    title=""
                    alt="布电线_06-tuya"
                  /><img
                    src="/common/1638863532520907.webp"
                    title=""
                    alt="布电线_07-tuya"
                  /><img
                    src="/common/1638863539257102.webp"
                    title=""
                    alt="布电线_08-tuya"
                  />
                </template>
                <template v-if="$route.query.type == '14'">
                  <img
                    src="/common/1638867621880393.webp"
                    title=""
                    alt="电力_03-tuya"
                  />
                  &nbsp;<img
                    src="/common/1638867627113887.webp"
                    title=""
                    alt="电力_05-tuya"
                  />
                  &nbsp;<img
                    src="/common/1638867634803680.webp"
                    title=""
                    alt="电力_08-tuya"
                  />
                  &nbsp;<img
                    src="/common/1638867639804653.webp"
                    title=""
                    alt="电力_09-tuya"
                  />
                  &nbsp;<img
                    src="/common/1638867646477548.webp"
                    title=""
                    alt="电力_12-tuya"
                  />
                </template>
                <template v-if="$route.query.type == '15'">
                  <img
                    src="/common/1638869184779549.webp"
                    title=""
                    alt="橡套_01-tuya"
                  /><img
                    src="/common/1638869188839377.webp"
                    title=""
                    alt="橡套_02-tuya"
                  /><img
                    src="/common/1638869194624194.webp"
                    title=""
                    alt="橡套_03-tuya"
                  /><img
                    src="/common/1638869199703558.webp"
                    title=""
                    alt="橡套_05-tuya"
                  />
                </template>

                <p style="text-align: center;"  v-if="$route.query.type == '16'"><img src="/common/1638869914430596.webp" title="" alt="控制_02-tuya"><img src="/common/1638869920251678.webp" title="" alt="控制_03-tuya"><img src="/common/1638869925138317.webp" title="" alt="控制_05-tuya"><img src="/common/1638869932343427.webp" title="" alt="控制_06-tuya"></p>


                <p style="text-align: center;"  v-if="$route.query.type == '17'"><img src="/common/1638870749601446.webp" title="" alt="低压无卤_03-tuya"><img src="/common/1638870752384395.webp" title="" alt="低压无卤_06-tuya"><img src="/common/1638870756746945.webp" title="" alt="低压无卤_08-tuya"><img src="/common/1638870762628509.webp" title="" alt="低压无卤_10-tuya"></p>

                <p style="text-align: center;" v-if="$route.query.type == '18'" ><img src="/common/1638873170405636.webp" title="" alt="高压_02-tuya"><img src="/common/1638873181139951.webp" title="" alt="高压_04-tuya"><img src="/common/1638873191596574.webp" title="" alt="高压_06-tuya"><img src="/common/1638873200994880.webp" title="" alt="高压_07-tuya"></p>


                <p style="text-align: center;" v-if="$route.query.type == '19'"><img src="/common/1638874691821922.webp" title="" alt="护套线_03-tuya"><img src="/common/1638874697770826.webp" title="" alt="护套线_06-tuya"><img src="/common/1638874708256543.webp" title="" alt="护套线_08-tuya"><img src="/common/1638874715496077.webp" title="" alt="护套线_11-tuya"></p>

                <p style="text-align: center;" v-if="$route.query.type == '20'"><img src="/common/1638877187851128.webp" title="" alt="集束_03-tuya"><img src="/common/1638877191226329.webp" title="" alt="集束_05-tuya"><img src="/common/1638877199234085.webp" title="" alt="集束_07-tuya"><img src="/common/1638877205109498.webp" title="" alt="集束_09-tuya"></p>

                <p style="text-align: center;" v-if="$route.query.type == '21'"><img src="/common/1638877917902523.webp" title="" alt="架空_03-tuya"><img src="/common/1638877937898386.webp" title="" alt="架空_06-tuya"><img src="/common/1638877942585288.webp" title="" alt="架空_09-tuya"><img src="/common/1638877945457128.webp" title="" alt="架空_10-tuya"></p>

                <p style="text-align: center;" v-if="$route.query.type == '22'"><img src="/common/1638879094653250.webp" title="" alt="矿物质_02-tuya"><img src="/common/1638879099328822.webp" title="" alt="矿物质_04-tuya"><img src="/common/1638879106640779.webp" title="" alt="矿物质_06-tuya"><img src="/common/1638879110864867.webp" title="" alt="矿物质_07-tuya"></p>


                <p style="text-align: center;" v-if="$route.query.type == '23'"><img src="/common/1638879860176427.webp" title="" alt="铝合金_01-tuya"><img src="/common/1638879865401223.webp" title="" alt="铝合金_03-tuya"><img src="/common/1638879870224524.webp" title="" alt="铝合金_05-tuya"></p>

                <p style="text-align: center;" v-if="$route.query.type == '24'"><img src="/common/1638880342540000.webp" title="" alt="特种_02-tuya"><img src="/common/1638880347658963.webp" title="" alt="特种_04-tuya"></p>

                <p style="text-align: center;" v-if="$route.query.type == '25'"><img src="/common/1638880978398396.webp" title="" alt="通信_02-tuya"><img src="/common/1638880983618780.webp" title="" alt="通信_05-tuya"><img src="/common/1638880989134469.webp" title="" alt="通信_06-tuya"></p>

                <p style="text-align: center;" v-if="$route.query.type == '26'"><img src="/common/1638881575936486.webp" title="" alt="阻燃_02-tuya"><img src="/common/1638881582190457.webp" title="" alt="阻燃_03-tuya"></p>

                <img
                  src="/common/1638864311547502.webp"
                  title=""
                  alt="布电线_09-tuya"
                /><img
                  src="/common/1638864528168695.webp"
                  title=""
                  alt="布电线_10-tuya"
                />
              </p>
            </div>
          </div>
          <div class="section section4" id="section4">
            <p class="t1">公司优势</p>
            <div class="row">
              <div class="col-md-6 col-12" style="box-sizing: border-box">
                <div class="item">
                  <i class="iconfont"></i>
                  <div class="txt">
                    <b>优良企业</b>
                    <p class="t2">公司是河南省专门生产电线电缆的优良企业</p>
                    <p class="t3">拥有先进生产设备和检测设备</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12" style="box-sizing: border-box">
                <div class="item">
                  <i class="iconfont"></i>
                  <div class="txt">
                    <b>公司实力</b>
                    <p class="t2">生产中心位于武陟县詹店工业园区</p>
                    <p class="t3">紧邻S86原焦高速、G107京深线，交通便利</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12" style="box-sizing: border-box">
                <div class="item">
                  <i class="iconfont"></i>
                  <div class="txt">
                    <b>人才体系</b>
                    <p class="t2">拥有技术精湛、勤学苦干的管理团队和技术人才</p>
                    <p class="t3">
                      有先进的科研集体、专业的销售及售后服务综合管理体系
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12" style="box-sizing: border-box">
                <div class="item">
                  <i class="iconfont"></i>
                  <div class="txt">
                    <b>服务质量</b>
                    <p class="t2">质量第一、诚信为本</p>
                    <p class="t3">为广大顾客提供优质的产品和全方面的服务</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="section section3" id="section3">
            <p class="t1">在线订购</p>
            <contact></contact>
          </div>
          <!-- <div class="prev_next">
            <div class="page-a">
              <div class="page-a">
                上一篇：<a href="/proinfo/104.html">布电线</a>
              </div>
            </div>
            <div class="page-a">
              <div class="page-a">
                下一篇：<a href="/proinfo/102.html">布电线</a>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import common from "./common.js";
import contact from "@/components/contact.vue";
export default {
  components: {
    swiper,
    swiperSlide,
    contact,

  },
  data() {
    return {
      imageList: common,
      swiperOptions: {
        loop: true,
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  computed: {
    list() {
      let type = this.$route.query.type ? this.$route.query.type : "13";

      let list = this.imageList.filter((item) => item.type == type);
      return list;
    },
    myTitle() {
      let type = this.$route.query.type;
      let list = this.imageList.filter((item) => item.type == type);
      return list.length > 0 ? list[0].label : "产品中心";
    },
  },
};
</script>

<style></style>
